module.exports = __webpack_public_path__ + "img/icon_star.9ee351d6.svg";